import { useState } from 'react';
import { Button } from '@optiaxiom/react';

import { useInstanceId } from '@frontend/hooks';

import { useStopSpecializedAgentExecution } from '../../hooks/useSpecializedAgents';
import { StopExecutionDialog } from '../specialized-agent/executions/StopExecutionDialog';

type StopExecutionButtonProps = {
  executionId: string;
  onSuccess?: () => void;
  buttonText?: string;
  buttonSize?: 'sm' | 'md' | 'lg';
};

export function StopExecutionButton({
  executionId,
  onSuccess,
  buttonText = 'Stop Execution',
  buttonSize = 'md',
}: StopExecutionButtonProps) {
  const { instanceId } = useInstanceId();
  const [isStopDialogOpen, setIsStopDialogOpen] = useState(false);

  const { mutate: stopExecution, isPending: isStoppingExecution } =
    useStopSpecializedAgentExecution(() => {
      setIsStopDialogOpen(false);
      onSuccess?.();
    });

  const handleStopExecution = () => {
    if (instanceId && executionId) {
      stopExecution({
        instanceId,
        executionId,
        errorMessage: 'The agent has been terminated manually',
      });
    }
  };

  return (
    <>
      <Button
        appearance="danger"
        size={buttonSize}
        onClick={() => setIsStopDialogOpen(true)}
        disabled={isStoppingExecution}
      >
        {buttonText}
      </Button>

      <StopExecutionDialog
        open={isStopDialogOpen}
        onOpenChange={setIsStopDialogOpen}
        onConfirm={handleStopExecution}
        isSubmitting={isStoppingExecution}
      />
    </>
  );
}
